import { getValueWithCurrency } from '@App/helpers/toCurrency'
import s from './styles.module.scss'

export const PositionDetailsPopUp = ({
  leverage,
  currency,
  margin,
  targetPrice,
}: {
  leverage: number
  currency: string
  margin: number
  targetPrice: number
}) => {
  return (
    <div className={s.container}>
      <div className={s.title}>Position Details</div>
      <div className={s.row}>
        <div className={s.name}>Trade size</div>
        <div className={s.value}>{getValueWithCurrency(currency, targetPrice)}</div>
      </div>
      <div className={s.row}>
        <div className={s.name}>Leverage</div>
        <div className={s.value}>{leverage}:1</div>
      </div>
      <div className={s.row}>
        <div className={s.name}>Margin</div>
        <div className={s.value}>{getValueWithCurrency(currency, margin)}</div>
      </div>
      <div className={s.row}>
        <div className={s.name}>Funding adjustments</div>
        <div className={s.value}>$1.33</div>
      </div>
    </div>
  )
}
